<template>
  <p>dashboard</p>
</template>

<script>
export default {
  name: 'Dashboard'
};
</script>
